import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './PortfolioContributors.css'
import {Row, Col} from 'react-flexbox-grid'
import {Bar} from 'react-chartjs'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import { LinkIcon } from '../'


@CSSModules(Styles)
export default class PortfolioContributors extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props);
    this.state = {
      viewTooltip: false
    }
  }
  clickViewTooltip = () =>{
    this.setState({viewTooltip: !this.state.viewTooltip})
  }
  clickCloseTooltip = () =>{
    this.setState({viewTooltip: false})
  }
  renderContributorsChart = (Cs) => {
    const chartOptions = {
      animation: false,
      responsive: true,
      maintainAspectRatio: false,
      scaleShowLabels: true,
      scaleShowGridLines: true,
      scaleShowVerticalLines: false,
      scaleShowHorizontalLines: true,
      showScale: true,
      scaleStartValue: 0,
    }
    const c_company_names = Cs.map((c) => {
      return format.longString(c.company_name)
    })
    const c_portfolio_weights = Cs.map((c) => { return +(parseFloat(c.portfolio_weight)).toFixed(2) })
    const c_emission_weights = Cs.map((c) => { return +(parseFloat(c.emission_weight)).toFixed(2) })
    const chartGray = '#D5D5D5'
    const chartRed = '#D2371B'
    const chartData = {
      labels: c_company_names,
      datasets: [{ label: 'Portfolio weight',
                   fillColor : chartGray,
                   strokeColor : chartGray,
                   highlightFill: chartGray,
                   highlightStroke: chartGray,
                   data: c_portfolio_weights},
                 { label: 'Emissions weight',
                   fillColor : chartRed,
                   strokeColor : chartRed,
                   highlightFill: chartRed,
                   highlightStroke: chartRed,
                   data: c_emission_weights}]
    }
    return (
      <Row styleName='portfolio-contributors-chart-wrap'>
        <Col xs={0} sm={1} />
        <Col xs={12} sm={10} styleName='portfolio-contributors-chart'>
          <Bar data={chartData} options={chartOptions}  />
        </Col>
        <Col xs={0} sm={1} />
      </Row>
    )
  }
  renderContributorsList = (Cs) => {
    return Cs.map( (c,idx) => {
      return (
        <li key={c.company_name} styleName='holding'>
          <div styleName='holding-name'>{idx+1}. {c.company_name}</div>
          <div styleName='holding-asset'>{format.perc(c.portfolio_weight / 100)} of assets</div>
          <div styleName='holding-invested'>{format.perc(c.emission_weight / 100)} of emissions</div>
        </li>
      )
    })
  }
  render() {
    function compare(a,b) {
      const a_weight = convert.float(a.portfolio_weight)
      const b_weight = convert.float(b.portfolio_weight)
      if (a_weight < b_weight) { return  1; }
      if (a_weight > b_weight) { return -1; }
      return 0;
    }
    const contributors = this.props.fund.portfoliocontributors.sort(compare)
    return (
      <div styleName='portfolio-contributors'>
        <div styleName='portfolio-contributors-inner'>
          <div styleName='portfolio-contributors-title'>Emissions of the top 10 fund holdings</div>
          <div styleName='portfolio-contributors-subtitle'>Top 10 holdings, portfolio weight and emissions weight (Scope 1 + 2)</div>
          <div styleName='portfolio-contributors-chart-notice' onClick={this.clickViewTooltip}><i className='fa fa-question-circle'></i> What does this mean?</div>
          {
            (this.state.viewTooltip)?(
              <div styleName='portfolio-contributors-chart-tooltip-wrap'>
                <div styleName='portfolio-contributors-chart-tooltip-inner'>
                  <div styleName='portfolio-contributors-chart-tooltip'>
                    <div styleName='portfolio-contributors-tooltip-close'
                      onClick={this.clickViewTooltip} title='Close'>
                      Close
                      <LinkIcon faclass='fa-times'/>
                    </div>
                    <p>This chart shows the 10 largest holdings in this fund's portfolio. The grey bars represent the portfolio weight of each holding. The red bars track what percent of the funds's overall emissions are associated with each holding. If a company's red bar is higher than its gray bar, it means the holding is responsible for an outsized amount of this fund's carbon footprint. </p>
                    <div styleName='portfolio-contributors-detail-holdings-wrap'>
                      <ul styleName='detail-holdings'>
                        {this.renderContributorsList(contributors)}
                      </ul>
                    </div>
                    <p>Relative carbon footprint is measured in metric tonnes of CO<sub>2</sub> or CO<sub>2</sub> equivalents per $1 million USD invested</p>
                  </div>
                </div>
              </div>
            ):null
          }
          {this.renderContributorsChart(contributors)}
        </div>
        { (this.state.viewTooltip)
            ?(<div styleName='tooltip-overlay' onClick={this.clickCloseTooltip}/>)
            :null }
      </div>
    )
  }
}

